import { toTime } from "@/helpers/tools";

export const FILTER_TYPE = {
  LIST: 1,
  RANGE: 2,
};

export const FILTER_ID = {
  LABELS: 7,
  NIGHTS_OF_STAY: 1,
  WENT_TIME: 2,
  RETURN_TIME: 3,
  HOTEL_STARS: 4,
  AIRLINE: 5,
  PRICE_RANGE: 6,
};

export const DAY_PERIODS = {
  MORNING: 1,
  NOON: 2,
  EVENING: 3,
  NIGHT: 4,
};

export const PARTS_OF_DAY = {
  [DAY_PERIODS.MORNING]: {
    start: toTime("2018-01-01T00:00:00"),
    end: toTime("2018-01-01T06:00:00"),
  },
  [DAY_PERIODS.NOON]: {
    start: toTime("2018-01-01T06:00:00"),
    end: toTime("2018-01-01T12:00:00"),
  },
  [DAY_PERIODS.EVENING]: {
    start: toTime("2018-01-01T12:00:00"),
    end: toTime("2018-01-01T18:00:00"),
  },
  [DAY_PERIODS.NIGHT]: {
    start: toTime("2018-01-01T18:00:00"),
    end: toTime("2018-01-01T23:59:59"),
  },
};

export const TIME_PERIOD_FILTERS = [
  {
    id: 1,
    title: "بامداد (۰۰:۰۰ الی ۰۶:۰۰)",
    value: DAY_PERIODS.MORNING,
  },
  {
    id: 2,
    title: "صبح (۰۶:۰۰ الی ۱۲:۰۰)",
    value: DAY_PERIODS.NOON,
  },
  {
    id: 3,
    title: "بعد از ظهر (12:00 الی 18:00)",
    value: DAY_PERIODS.EVENING,
  },
  {
    id: 4,
    title: "عصر و شب (۱۸:۰۰ الی ۲۴:۰۰)",
    value: DAY_PERIODS.NIGHT,
  },
];

export const LABELS = [
  {
    id: 1,
    value: 1,
    title: "تور های دارای تخفیف",
  },
  // {
  //   id: 2,
  //   value: 2,
  //   title: "تور های اقساطی"
  // },
  {
    id: 4,
    value: 4,
    title: "تور های لحظه آخری",
  },
];
